<template>
    <div>
        <p>
            <strong>Nombre: </strong>
            <span>{{ estudianteObject.nombre + " " + estudianteObject.apellido_paterno + " " + estudianteObject.apellido_materno }}</span>
            <br />
            <strong>Matrícula: </strong>
            <span>{{ estudianteObject.matricula ? estudianteObject.matricula : "-" }}</span>
            <br />
            <strong>Estado: </strong>
            <span>{{ estudianteObject.estado ? estudianteObject.estado : "-" }}</span>
            <hr/>
        </p>
        
        <p>
            <strong>Fecha nacimiento: </strong>
            <span>{{ estudianteObject.fecha_nacido ? estudianteObject.fecha_nacido : "-" }}</span>
            <br />
            <strong>Sexo: </strong>
            <span>{{ estudianteObject.sexo ? estudianteObject.sexo.nombre : "-" }}</span>
            <br />
            <strong>Peso: </strong>
            <span>{{ estudianteObject.peso ? estudianteObject.peso : "-" }}</span>
            <br />
            <strong>Estatura: </strong>
            <span>{{ estudianteObject.estatura ? estudianteObject.estatura : "-" }}</span>
            <hr />
        </p>

        <p>
            <strong>Fecha de alta: </strong>
            <span>{{ estudianteObject.fecha_alta ? estudianteObject.fecha_alta : "-" }}</span>
            <br />
            <strong>Fecha de baja: </strong>
            <span>{{ estudianteObject.fecha_baja ? estudianteObject.fecha_baja : "-" }}</span>
            <br />
            <strong>Escuela de procedencia: </strong>
            <span>{{ estudianteObject.escuela_procedencia ? estudianteObject.escuela_procedencia : "-" }}</span>
            <br />
            <strong>Domicilio: </strong>
            <span>{{ estudianteObject.domicilio ? estudianteObject.domicilio : "-" }}</span>
            <br />
            <strong>Transporte escolar: </strong>
            <span v-if="estudianteObject.tipo_transporte_escolar !== 4">{{ estudianteObject.tipo_transporte_escolar ? transporte_escolar[ estudianteObject.tipo_transporte_escolar - 1 ] : "-" }}</span>
            <span v-else>{{ estudianteObject.tipo_transporte_escolar ? estudianteObject.tipo_transporte_escolar : "-" }}</span>
        <hr />
        </p>

        <p>
            <strong>Padre o tutor: </strong>
            <span>{{ estudianteObject.padre ? estudianteObject.padre.nombre + " " + estudianteObject.padre.apellido_paterno + " " + estudianteObject.padre.apellido_materno : "-" }}</span>
            <br />
            <strong>Madre o tutor: </strong>
            <span>{{ estudianteObject.madre ? estudianteObject.madre.nombre + " " + estudianteObject.madre.apellido_paterno + " " + estudianteObject.madre.apellido_materno : "-" }}</span>
            <br />
            <strong>convive con: </strong>
            <span>{{ estudianteObject.convive_con !== null ? convive_con[estudianteObject.convive_con] : "-" }}</span>
            <br />
            <strong>Cantidad de hermanos: </strong>
            <span>{{ estudianteObject.cantidad_hermanos ? estudianteObject.cantidad_hermanos : "-" }}</span>
            <br />
            <strong>Cantidad de habitantes: </strong>
            <span>{{ estudianteObject.cantidad_habitantes ? estudianteObject.cantidad_habitantes : "-" }}</span>
        <hr />
        </p>

        <p>
            <strong>Estado nutricional: </strong>
            <span>{{ estudianteObject.estado_nutricional ? estado_nutricional[ estudianteObject.estado_nutricional - 1] : "-" }}</span>
            <br />
            <strong>Tipo de sangre: </strong>
            <span>{{  estudianteObject.tipo_sangre ? estudianteObject.tipo_sangre.nombre : "-" }}</span>
            <br />
            <strong>Servicio médico: </strong>
            <span>{{  estudianteObject.servicio_medico ? estudianteObject.servicio_medico.nombre : "-"}}</span>
            <br />
            <strong>Agudeza visual: </strong>
            <span>{{  estudianteObject.agudeza_visual ? agudeza_visual[estudianteObject.agudeza_visual - 1] : "-"}}</span>
        <hr />
        </p>

        <p>
            <strong>Alergias: </strong>
            {{ !estudianteObject.alergias ? "-" : "" }}
            <template v-if="estudianteObject.alergias">
                                                                    <span
                                                                        :key="alergia"
                                                                        v-for="(alergia, index) in getItemsArray(
                                                                            estudianteObject.alergias
                                                                        )"
                                                                    >
                                                                        <br v-if="index !== 0" />
                                                                        {{ alergia }}
                                                                    </span>
            </template>
            <br />
            <strong>Padecimientos: </strong>
            {{ !estudianteObject.padecimientos ? "-" : "" }}
            <template v-if="estudianteObject.padecimientos">
                                                                    <span
                                                                        :key="padecimiento"
                                                                        v-for="(padecimiento, index) in getItemsArray(
                                                                            estudianteObject.padecimientos
                                                                        )"
                                                                    >
                                                                        <br v-if="index !== 0" />
                                                                        {{ padecimiento }}
                                                                    </span>
            </template>
            <br />
            <strong>Medicamentos: </strong>
            {{ !estudianteObject.medicamentos ? "-" : "" }}
            <template v-if="estudianteObject.medicamentos">
                                                                    <span
                                                                        :key="medicamento"
                                                                        v-for="(medicamento, index) in getItemsArray(
                                                                            estudianteObject.medicamentos
                                                                        )"
                                                                    >
                                                                        <br v-if="index !== 0" />
                                                                        {{ medicamento }}
                                                                    </span>
            </template>
        <hr />
        </p>

        <p>
            <strong>Documentos entregados: </strong>
            <br />
            <strong>Acta de nacimiento: </strong>
            <span>{{ getItemValue(estudianteObject.ractanacido) }}</span>
            <br />
            <strong>Carta de buena conducta: </strong>
            <span>{{  estudianteObject.rcarta_buena_conducta === 1 ? "si" : "No" }}</span>
            <br />
            <strong>Carta de no adeudo: </strong>
            <span>{{  estudianteObject.rcarta_no_adeudo === 1 ? "si" : "No"}}</span>
            <br />
            <strong>Certificado de primaria: </strong>
            <span>{{  getItemValue(estudianteObject.rcertificado_primaria)}}</span>
            <br />
            <strong>Boleta de primer año: </strong>
            <span>{{  getItemValue(estudianteObject.rboleta_primer_anyo)}}</span>
            <br />
            <strong>Boleta de segundo año: </strong>
            <span>{{  getItemValue(estudianteObject.rboleta_segundo_anyo)}}</span>
            <br />
            <strong>Constancia de examen: </strong>
            <span>{{  getItemValue(estudianteObject.rconstancia_examen)}}</span>
        <hr />
        </p>

        <p>
            <strong>Documentos entregados: </strong>
            <br />
            <strong>Examen médico: </strong>
            <span>{{estudianteObject.rexamen_medico === 1 ? "si" : "No" }}</span>
            <br />
            <strong>CURP: </strong>
            <span>{{  estudianteObject.rcurp === 1 ? "si" : "No" }}</span>
            <br />
            <strong>Contrato: </strong>
            <span>{{  estudianteObject.rcontrato === 1 ? "si" : "No"}}</span>
            <br />
            <strong>Aviso de privacidad: </strong>
            <span>{{  estudianteObject.raviso_privacidad === 1 ? "si" : "No"}}</span>
            <br />
            <strong>Ficha de inscripcion: </strong>
            <span>{{  estudianteObject.rfecha_inscripcion === 1 ? "si" : "No"}}</span>
            <br />
            <strong>Reglamento: </strong>
            <span>{{  estudianteObject.rreglamento === 1 ? "si" : "No"}}</span>
            <br />
            <strong>Hoja de informes: </strong>
            <span>{{  estudianteObject.rhoja_informes === 1 ? "si" : "No"}}</span>
        <hr />
        </p>
    </div>
</template>

<script>
export default {
    name: "PrintEstudianteTemplate",
    props: {
        estudianteObject: { type: Object, default: null }
    },
    data() {
        return {
            servicio_medico: ["IMSS", "ISSSTE", "PEMEX", "Otro"],
            convive_con: ["Sin padres", "Madre", "Padre", "Madre y Padre"],
            estado_nutricional: ["Nutrición normal", "Desnutrición moderada", "Desnutrición severa"],
            agudeza_visual: ["Normal", "Disminuída", "Usa lentes"],
            transporte_escolar: ["Transporte escolar", "Vienen por él", "Se va solo"]
        }
    },
    methods: {
        getItemsArray(string) {
            return string.split(",")
        },

        getItemValue(value) {
            switch (value) {
                case 1:
                    return "No"
                case 2:
                    return "Original"
                case 3:
                    return "Copia"
                default:
                    return "Valor incorrecto"
            }
        },
    }
}
</script>

<style scoped></style>
